var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-6 d-flex align-center justify-center",style:({
    borderRadius: '5px 5px 30px 30px',
    borderTop: `10px solid ${_vm.color}`,
    overflow: 'auto',
    color: _vm.text_color,
  }),attrs:{"flat":"","height":"166"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }